<template>
    <div class="input-group" :class="{'has-length': hasLength}">
        <div v-if="prependText || prependIcon" class="input-group-prepend">
            <span class="input-group-text">
                <template v-if="prependText">
                    {{prependText}}
                </template>
                <font-awesome-icon v-else :icon="prependIcon2"/>
            </span>
        </div>
        <slot/>
        <div v-if="appendText || appendIcon || $slots['append-slot']" class="input-group-append">
            <slot v-if="$slots['append-slot']" name="append-slot"/>
            <span v-else class="input-group-text">
                <template v-if="appendText">
                    {{appendText}}
                </template>
                <font-awesome-icon v-else-if="appendIcon" :icon="appendIcon2"/>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "input-group",
        data() {
            return {
                hasLength: false
            }
        },
        props: {
            prependText: {
                type: String,
                required: false
            },
            prependIcon: {
                required: false
            },
            appendText: {
                type: String,
                required: false
            },
            appendIcon: {
                required: false
            }
        },
        computed: {
            prependIcon2 () {
                if (typeof this.prependIcon === "string") {
                    return ['fal', this.prependIcon]
                } else {
                    return this.prependIcon
                }
            },
            appendIcon2 () {
                if (typeof this.appendIcon === "string") {
                    return ['fal', this.appendIcon]
                } else {
                    return this.appendIcon
                }
            }
        },
        mounted() {
            const input = this.$el.querySelector("input,select,textarea");
            if (!input){
                return;
            }
            input.addEventListener("focus", this.inputFocus);
            input.addEventListener("blur", this.inputBlur);
        },
        beforeDestroy() {
            const input = this.$el.querySelector("input,select,textarea");
            if (!input){
                return;
            }
            input.removeEventListener("focus", this.inputFocus);
            input.removeEventListener("blur", this.inputBlur);
        },
        methods: {
            inputFocus: function () {
                this.hasLength = true;
            },
            inputBlur: function () {
                this.hasLength = false;
            },
        }
    }
</script>
